import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navigation from './components/Navigation';
import Resume from './pages/Resume';
import Blog from './pages/Blog';
import Papers from './pages/Papers';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Navigation />
        <main className="site-main">
          <Routes>
            <Route path="/" element={<Resume />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/papers" element={<Papers />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;
